export const G_USERINFO 	  = 'G_USERINFO'
export const G_LOADING  	  = 'G_LOADING'
export const G_DIRECTION  	  = 'G_DIRECTION'
export const G_INITIALIZE  	  = 'G_INITIALIZE'
export const G_URL            = 'G_URL'
export const G_MENU           = 'G_MENU'
export const G_POSTCODE       = 'G_POSTCODE'
export const G_LEADER         = 'G_LEADER'
export const G_LEADER_EMP     = 'G_LEADER_EMP'
export const G_DATA           = 'G_DATA'
export const G_CARTNUM        = 'G_CARTNUM'
export const G_MSGNUM         = 'G_MSGNUM'
export const SET_COMMENT      = 'SET_COMMENT'
export const SET_DEVICE       = 'SET_DEVICE'
export const SET_POSITION     = 'SET_POSITION'
export const G_GUESTBOOKING   = 'G_GUESTBOOKING'
